module.exports = __webpack_public_path__ + "img/weather_icon_bw.2e9200a0.png";